import { Component, ChangeDetectorRef, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { CurrencyPipe } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { HelperService, HTTPService, DateService, DataService } from 'app/services';
import { config, workStateIconSolid, workStateTitle } from 'app/constants';
import { currency } from 'app/constants/currency.constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { coreAndReturnMap } from 'app/constants/core-and-return.constants';
import { itemTypeIcons, itemTypeLabel } from 'app/constants/itemType.constants';
import { Subject } from 'rxjs';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { CannedServiceDialogComponent, TechFlagDialogComponent } from 'app/modules/app-components';
import { PartAddInventoryDialogComponent } from 'app/modules/app-components/part-add-inventory-dialog/part-add-inventory-dialog.component';
import { CatalogueDialogComponent } from '../catalogue-dialog/catalogue-dialog.component';
import { CoreAndPartReturnDialogComponent } from 'app/modules/app-components/returns/core-and-part-return-dialog/core-and-part-return-dialog.component';
import { CoreAndTireReturnDialogComponent } from 'app/modules/app-components/returns/core-and-tire-return-dialog/core-and-tire-return-dialog.component';
import { findIndex, trim, round, toString } from 'lodash';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-service-card',
  templateUrl: './service-card.component.html',
  styleUrls: ['./service-card.component.scss'],
  providers: [DialogService],
})
export class ServiceCardComponent implements OnInit, OnDestroy {
  @Input() invoicedRO: boolean = false;
  @Input() isArchived: boolean;
  @Input() adHocMap: any = {};
  @Input() partOrderingStatus: any = {};
  @Input() customFleetSettings: any = {};
  // For Advance pricing
  @Input() partPricingRule: any = {};
  @Input() partOverRideToApply: any = {};
  @Input() tireOverRideToApply: any = {};
  @Input() tirePricingRule: any = {};
  @Input() isOtherTaxable: boolean = false;
  @Input() isSubletTaxable: boolean = false;
  @Input() roundOffTax: boolean = false;
  @Input() isMitchell1Loading: boolean = false;
  @Input() isMitchellIntegrationEnabled: boolean = false;
  @Input() isMitchell1Connected: boolean = false;
  @Input() isReturnFeatureEnabled: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() isAdminTechControlEnabled: boolean = false;
  @Input() isPartsOrderingDisassociateEnabled: boolean = false;
  @Input() isDiscountItemEnabled: boolean = false;
  @Input() isQuickbooksCalCompatibiltyOn: boolean = false;
  @Input() isRepairDiagramEnabled: boolean = false;
  @Input() cardIndex: number;
  @Input() service: any = {};
  @Input() pricingList: any = [];
  @Input() getPartsOrderingPONumber: any = {};
  @Input() motorIncludedServiceTooltip: string = '';
  @Input() serviceTags: any[] = [];
  @Input() technicians: any[] = [];
  @Input() itemTypeOptions: any[] = [];
  @Input() defaultItemTypeOptions: any[] = [];
  @Input() orderTitle: string = '';
  @Input() motorVehicle: any = {};
  @Input() estimateId: string = '';
  @Input() customerId: string = '';
  @Input() vehicleId: string = '';
  @Input() vehicleName: string = '';
  @Input() estimateCode: string = '';
  @Input() serviceTitle: string = '';
  @Input() defaultTax: any = {};
  @Input() qboRefs: any = {};
  @Input() serviceInspectionLoading: boolean = false;
  @Input() isDeferredServiceEnabled: boolean = false;
  @Input() isAssigningTech: boolean = false;
  @Input() isPartsOrdingCostEditabled: boolean = false;
  @Input() isMitchell1EstimatorEnabled: boolean = false;
  @Input() isBillableHoursEnabled: boolean = false;
  @Input() enableMandatoryVin: boolean = false;
  @Input() isMileageMandatory: boolean = false;
  @Input() hideCost: boolean = true;
  @Input() cheque: number = 0;
  @Input() card: number = 0;
  @Input() cash: number = 0;
  @Input() creditPayment: number = 0;
  @Input() thirdParty: number = 0;
  @Input() remainingAmount: number = 0;
  @Input() techInitials: any = {};
  @Input() motorLaborPricing: any = {};
  @Input() itemSettings: any = {};
  @Input() isPartOrderingOrdered: any;
  @Input() isItemAlreadyExists: any;
  @Input() countOfItemsExistsInFees: any;
  @Input() isBalanceNegative: any;
  @Input() isOverrideCostWithTechRate: boolean = false;
  @Input() isItemOrderQtyChangeFromALEnabled: boolean = false;
  @Input() isServiceCollapse: boolean = true;
  @Input() serviceActionOptions: any[] = [
    { name: 'Delete', value: 'delete' },
    { name: 'Add return', value: 'item' },
    { name: 'Add core', value: 'core' },
  ];
  @Input() isManualPartOrderingEnabled: boolean = false;
  @Input() isArchivedRO: boolean = false;
  @Input() serviceNotesLabel: string = '';
  @Input() invoiceType: string = '';
  @Input('serviceLength')
  set serviceLength(serviceLength: any) {
    // ALP-19701
    // if (this.cardIndex === 0 && (!this.service.title || this.service.title === 'Untitled')) {
    //   this.timeoutRef = setTimeout(() => (this.focus.title = true), 1);
    // }
  }
  @Input('isTechFlag')
  set isTechFlag(isTechFlag: boolean) {
    this.setTechFlag();
  }
  @Input('isOfficeFlag')
  set isOfficeFlag(isOfficeFlag: boolean) {
    this.setOfficeFlag();
  }
  @Input('handleTechCard')
  set handleTechCard(showTechCard: any) {
    if (showTechCard && showTechCard.data) {
      const { key, data } = showTechCard;
      if (key === 'open-tech-card') {
        if (data?.serviceId && data?.techId) {
          const id = `tech-${data.techId}-${data.serviceId}`;
          this.isTechCardOpen = true;
          this.isTechnicianDetailsVisible = false;
          document.getElementById(id).click();
        }
      }
    }
  }
  @Input('handleOpenFlagRaiseCard')
  set handleOpenFlagRaiseCard(showCard: any) {
    if (showCard && showCard.data) {
      const { key, data } = showCard;
      if (this.service._id === data.serviceId) {
        if (key === 'open-flag-raise-card') {
          if (data.type === 'officeFlag') {
            this.service.openOfficeNote = true;
            const id = `office-flag-${data.serviceId}`;
            document.getElementById(id).click();
          } else {
            this.service.openTechNote = true;
            const id = `tech-flag-${data.serviceId}`;
            document.getElementById(id).click();
          }
        }
      }
    }
  }
  @Input('handleTechDetails')
  set handleTechDetails(techDetails: any) {
    if (techDetails && techDetails.data) {
      const { key, data } = techDetails;
      if (key === 'tech-details') {
        if (data.response) {
          this.getTechDetails(this.service[this.cardId]?.techId);
        }
      }
    }
  }
  @Input() subletPricing: any = {};
  @Input() isUpdatingServices: boolean = false;
  @Input() isLockedRO: boolean = false;
  @Input() partsLookupDropDownList: any[] = [];
  @Input() customer: any = {};
  @Input() isPartsTechConnected: boolean = false;
  @Input() isNexpartConnected: boolean = false;
  @Input() warehouses: any = [];
  @Input() isFinalizedRo: boolean = false;
  @Input() isDvi2Enabled: boolean = false;
  @Input() currentLang: string = 'en';
  @Input() companyLocalization: boolean = false;


  @Output() openRepairDialogram = new EventEmitter();
  @Output() appHandleOpenMitchellInterface = new EventEmitter();
  @Output() serviceDelete = new EventEmitter();
  @Output() updateItemPriceAndCount = new EventEmitter();
  @Output() calculateAllTotal = new EventEmitter();
  @Output() appTagCreated = new EventEmitter();
  @Output() appUpdateService = new EventEmitter();
  @Output() openInspectionImportDialog = new EventEmitter();
  @Output() deleteInspection = new EventEmitter();
  @Output() openInspectionDialog = new EventEmitter();
  @Output() generateActivity = new EventEmitter();
  @Output() techAssignSuccess: EventEmitter<any> = new EventEmitter();
  @Output() handleEstimateAction: EventEmitter<any> = new EventEmitter();
  @Output() updateTags: EventEmitter<any> = new EventEmitter();
  @Output() techFlag: EventEmitter<any> = new EventEmitter();
  @Output() appOpenAssignTechDialog: EventEmitter<any> = new EventEmitter();
  @Output() openTechDetailCard: EventEmitter<any> = new EventEmitter();
  @Output() openItemDialog: EventEmitter<any> = new EventEmitter();
  @Output() appEmitCostUpdated: EventEmitter<any> = new EventEmitter();
  @Output() getEstimatesById: EventEmitter<any> = new EventEmitter();
  @Output() appOpenMotorServiceDialog: EventEmitter<any> = new EventEmitter();
  @Output() appUpdateServiceDirect = new EventEmitter();
  @Output() appHandleOnlinOrderAction: EventEmitter<any> = new EventEmitter();
  @Output() isServicesAOpen: EventEmitter<any> = new EventEmitter();
  @Output() removedPartsLookupAndReplace: EventEmitter<any> = new EventEmitter();
  @Output() appOpenAssignSaleCodeModal = new EventEmitter();
  @Output() appOpenVehicleActionModal = new EventEmitter();

  @ViewChild('serviceCard', { static: true }) serviceCard: ElementRef;
  _serviceIds: any[] = [];

  serviceStatusBadge = {
    pending: {
      name: 'Not yet authorized',
      class: 'badge-pending',
    },
    approved: {
      name: 'Approved',
      class: 'badge-authorized',
    },
    deferred: {
      name: 'Deferred',
      class: 'badge-deferred',
    },
    deferredLocked: {
      name: 'Deferred locked',
      class: 'badge-deferred',
    },
    declined: {
      name: 'Declined',
      class: 'badge-declined',
    },
    archived: {
      name: 'Archived',
      class: 'badge-pending',
    },
  };
  usd: string = currency.USD;
  timeoutRef: any;
  config: any = config;
  activeRow: number = 0;
  closeItem: number = 0;
  closeAllItem: number;
  errors: any = {};
  acFocus: any = {
    title: false,
    notes: false,
    tech: false,
  };
  acFocusLabel: any = {
    title: 'Enter name of the service',
    notes: 'Add Note',
  };
  acNotDisable: any = {
    customer: true,
    estimate: true,
  };
  focus: any = {};
  inProgressService: any = {};
  currentService: any = {};
  employee: any = {};
  totalTimeSpent: any = 0;
  defaultService: any = {};
  serviceActions = [
    { name: 'Save as Canned Service', value: 'save-as' },
    { name: 'Rearrange Services', value: 'RearrangeServices' },
  ];
  notesRows: number;
  dragDisabled = true;
  isInvalidDragEvent: boolean = false;
  isTechCardOpen: boolean = false;
  adminUpdatedAt: any;
  techUpdatedAt: any;
  workStateTitle: any = {};
  workStateIconSolid: any = {};
  isWorkAsTechEnabled: boolean = false;
  uniqueInternalReferenceCount = { count: Date.now() };
  icons = itemTypeIcons;
  labels = itemTypeLabel;
  serviceTitleIcons = {
    Motor: {
      imageIcon: './assets/img/motor-service-icon.svg',
      name: 'Motor Repair Guide',
      class: 'motor-icon',
      value: 'motor-repair',
      altText: 'MOTOR',
      imageStyle: {
        height: '16px',
        width: '16px',
        'margin-top': '-3px',
      },
    },
    Mitchell1: {
      name: 'Mitchell1 Repair Guide',
      value: 'mitchell1-repair',
      class: 'm1',
      imageIcon: './assets/img/m1-icon-service.svg',
      altText: 'M1-1',
      disabled: this.isMitchell1Loading,
      imageStyle: {
        height: '16px',
        width: '16px',
        'margin-top': '-3px',
      },
    },
  };
  autoLeapManualService = {
    imageIcon: './assets/img/al-icon-service.svg',
    altText: 'manual-service',
    class: 'motor-icon',
    value: 'manual-service',
  };
  interval: any = '';
  isTechnicianDetailsVisible: boolean = false;
  techServiceStatus: string = '';
  cardId: string = '';
  currentDateTime: any = 0;
  timeAllocated: string = '0:00';
  timeSpent: string = '0:00';
  timeAllocatedMin: number = 0;
  costEstimatedHour: number = 0;
  timeSpentMin: number = 0;
  isProcessing: boolean = false;
  isLoading: boolean = false;
  isClockIn: boolean = false;
  unsubscribe: Subject<boolean> = new Subject<boolean>();
  techID: any = '';
  data: any;
  flagNote: string = '';
  defaultNote: string =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis nulla vel tortor pellentesque aliquet vitae eget ipsum. Aliquam suscipit orci eros, sed porta velit dictum ornare.';
  submitFlag: boolean = false;
  newDate: string = '';
  techFlagNoteStatus = {
    open: {
      name: 'Active',
      class: 'badge-open',
    },
    resolved: {
      name: 'Resolved',
      class: 'badge-resolved',
    },
  };
  officeFlagNoteStatus = {
    open: {
      name: 'Active',
      class: 'badge-open',
    },
    resolved: {
      name: 'Resolved',
      class: 'badge-resolved',
    },
  };
  techFlagStatus: string = '';
  officeFlagStatus: string = '';
  techFlagResolved: boolean = false;
  isAddUserResponse: boolean = false;
  userName: string = '';
  isFlagRaised = false;
  isHideTechTextbox: boolean = false;
  isHideAdminTextbox: boolean = false;
  techStatusCount: number = 0;
  adminStatusCount: number = 0;
  serviceDetails = {
    imageIcon: '',
    class: '',
    altText: '',
  };
  notesLabel: string = '';
  isOpenAccordion: boolean = true;
  subscription: Subscription;
  dataServiceListeners: any[] = [];
  reRenderInspection: boolean = false;
  @Input() isStickyGrossProfitValuesEnabled: boolean = false;
  isLocalStickyGrossProfitValues: boolean = false;
  constructor(
    public helperService: HelperService,
    private httpService: HTTPService,
    private dialogService: DialogService,
    private dateService: DateService,
    private currencyPipe: CurrencyPipe,
    public dataService: DataService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.userName = this.helperService.getCompany().userName;
    const listener = this.dataService.getData().subscribe((obj) => {
      const data = obj.data;

      if (data.key === 'call-update-service' && data?.data?.status) {
        this.updateService(data?.data?.value)
      }
      if (data.key === 'load-service-inspection' && data?.data?.status) {
        if(this.service._id === data?.data?.value?.serviceId) {
          this.serviceInspectionLoading = true;
          this.service.inspection = data.data?.value.inspection
          setTimeout(() => {
            this.serviceInspectionLoading = false;
          }, 500);
        }
        
      }
    })
    this.dataServiceListeners.push(listener);
    // if tech has not added any notes

    this.setTechFlag();
    this.setOfficeFlag();

    if (!this.service.title && !this.service?.items?.length && !this.service?.items[0]?.title) {
      this.focus.title = true;
    }

    // if (!this.service.title && this.service?.items?.length && this.service?.items[0]?.title) {
    //   this.service.title = this.service?.items[0]?.title;
    // }

    if (this.service.title) {
      this.acFocusLabel.title = this.service.title;
    }

    if (this.service.notes) {
      this.acFocusLabel.notes = this.service.notes;
      this.notesRows = 3;
    } else {
      this.notesRows = 1;
    }

    const lastItem = [...this.service.items].pop();

    if (this.service.isAddTireStorageField) {
      this.addRow({ index: this.service.items.length, type: 'tireStorage', isFocusTitle: this.service.isAddTireStorageField });
      this.service.isAddTireStorageField = false;
    }

    if (!lastItem || (lastItem && lastItem.title) || lastItem.type || lastItem.count || lastItem.price) {
      this.service.items.push({
        title: null,
        titleFR: null,
        type: null,
        isTaxable: false,
        count: '',
        price: null,
        discount: this.helperService.deepCopy(config.estimate.discountType[0]),
        discountAmt: null,
        taxAmt: null,
        subTotal: 0,
        tags: [],
        description: '',
        descriptionFR: '',
        displayHoursOnOrder: false,
        displayDescOnOrder: false,
      });
    }

    this.workStateTitle = workStateTitle;
    this.workStateIconSolid = workStateIconSolid;
    this.setServiceDetails();
    const getOpenInpsectionModal = JSON.parse(localStorage.getItem('openInsectionModal'));

    if (getOpenInpsectionModal) {
      const { inspectionId, isInspection, serviceId, associatedInspectionId } = getOpenInpsectionModal;

      if (isInspection) {
        this.handleOpenInspectionDialog({ inspectionId: inspectionId, associatedInspectionId: associatedInspectionId });
        localStorage.removeItem('openInsectionModal');
      }
    }

    this.isWorkAsTechEnabled = this.helperService.getCompany().isWorkAsTechEnabled;

    if (this.isWorkAsTechEnabled) {
      this.serviceActions.push({ name: 'View as Technician', value: 'viewAsTech' });
    }
  }

  toggleCollapseState() {
    this.isLocalStickyGrossProfitValues = !this.isLocalStickyGrossProfitValues;
  }

  get totalDiscounts(): number {
    return this.service.serviceTotal.serviceLevelDiscount + this.service.serviceTotal.itemLevelDiscount;
  }

  get totalCosts(): number {
    const totalCost = this.service.items.reduce((sum, item, index, array) => {
      if (index === array.length - 1) {
        return sum;
      }
      let itemCost = 0;
      if (item.type === 'labor') {
        itemCost = item.cost;
      } else if(item.type === 'discount') {
        itemCost = 0;
      } else {
        itemCost = item.cost ? item.cost * item.count : 0;
      }
      return sum + itemCost;
    }, 0);
    return totalCost;
  }

  get totalEstimatedHours(): number {
    return this.service.items.reduce((sum, item) => {
      if (item.type === 'labor') {
        return sum + item.count;
      } else if (item.type === 'bundle' && Array.isArray(item.subItems)) {
        const subItemLaborCount = item.subItems
          .filter(subItem => subItem.type === 'labor')
          .reduce((subSum, subItem) => subSum + subItem.count, 0);
        return sum + subItemLaborCount;
      }
      return sum;
    }, 0);
  }

  get serviceNetTotal(): number {
    return this.service.serviceTotal.total - this.totalDiscounts;
  }

  get grossProfitValue(): number {
    const totalDiscounts = this.totalDiscounts;
    const totalCosts = this.totalCosts;
    return this.service.serviceTotal.total - totalDiscounts - totalCosts;
  }

  get grossProfitPercentage(): number {
    const totalDiscounts = this.totalDiscounts;
    const totalCosts = this.totalCosts;
    const numerator = (this.service.serviceTotal.total - totalDiscounts) - totalCosts;
    const denominator = this.service.serviceTotal.total - totalDiscounts;
    return denominator !== 0 ? numerator / denominator : 0;
  }

  get grossProfitDollarPerHour(): number | string {
    const serviceNetTotal = this.serviceNetTotal;
    const totalCost = this.totalCosts;
    const calculation = serviceNetTotal - totalCost;
    return this.totalEstimatedHours > 0
      ? calculation / this.totalEstimatedHours
      : '-';
  }

  openAssignSaleCodeModal(serviceItem: any) {
    this.appOpenAssignSaleCodeModal.emit(serviceItem);
  }

  getCategoriesCount() {
    if (this.service && this.service.inspection && this.service.inspection.inspectionId) {
      const { category } = this.service.inspection.inspectionId;
      if (category) {
        const categoryLength = category.length;
        let itemsCount = 0;
        category?.forEach((service) => {
          itemsCount += service?.inspectionItems?.length ?? 0;
        });
        return `${categoryLength} categories ${itemsCount} items`;
      }
    }

    return null;
  }

  updateFlagDetails(data) {
    if (data && data._id) {
      const { _id, tech, techFlag, isTechFlag, officeFlag, isOfficeFlag } = data;
      if (this.service._id === _id) {
        this.service.techFlag = { ...(techFlag || {}) };
        this.service.isTechFlag = isTechFlag;
        this.service.tech = tech;
        this.service.officeFlag = { ...(officeFlag || {}) };
        this.service.isOfficeFlag = isOfficeFlag;
        this.setTechFlagColor();
        this.setOfficeFlagIcon();
        this.setOfficeFlag();
        this.setTechFlag();
      }
    }
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.dataServiceListeners.forEach((listener) => {
      try {
        listener.unsubscribe();
      } catch (err) { }
    });
  }

  setTechFlag() {
    const { isTechFlag, techFlag } = this.service;

    if (isTechFlag && techFlag) {
      if (techFlag.techUpdatedAt) {
        this.service.techUpdatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(techFlag.techUpdatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (techFlag.adminUpdatedAt) {
        this.service.adminUpdatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(techFlag.adminUpdatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (techFlag.resolvedAt) {
        this.service.resolvedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(techFlag.resolvedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (techFlag?.flagStatus) {
        this.techFlagStatus = techFlag?.flagStatus;
      }

      if (this.service?.techFlag?.adminNotes) {
        this.isHideTechTextbox = true;
        this.isAddUserResponse = true;
      }

      if (techFlag.adminNotes) {
        this.service.techFlag.adminNotes = techFlag.adminNotes;
        this.service.techFlag.defaultNote = this.helperService.deepCopy(techFlag.adminNotes);
      }

      if (this.flagNote && this.service?.techFlag?.flagStatus !== 'resolved') {
        this.isAddUserResponse = true;
        if (!this.service?.techFlag?.adminNotes) {
          this.isHideTechTextbox = false;
        }
      }

      //get latest date
      if (techFlag.techUpdatedAt && techFlag.adminUpdatedAt) {
        if (new Date(techFlag.techUpdatedAt).getTime() > new Date(techFlag.adminUpdatedAt).getTime()) {
          this.service.techFlag.isTechLatest = true;
          this.service.techFlag.isOfficeLatest = false;
        } else {
          this.service.techFlag.isTechLatest = false;
          this.service.techFlag.isOfficeLatest = true;
        }
      } else {
        this.service.techFlag.isTechLatest = true;
        this.service.techFlag.isOfficeLatest = false;
      }
    }
  }

  setOfficeFlag() {
    const { officeFlag, isOfficeFlag } = this.service;

    if (isOfficeFlag && officeFlag) {
      if (officeFlag.techUpdatedAt) {
        this.service.officeTechUpdatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(officeFlag.techUpdatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }

      if (officeFlag.adminUpdatedAt) {
        this.service.officeAdminUpdatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(officeFlag.adminUpdatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
      }
      if (officeFlag?.flagStatus) {
        this.officeFlagStatus = officeFlag?.flagStatus;
      }
      if (officeFlag.adminNotes) {
        this.flagNote = officeFlag.adminNotes;
        this.service.officeFlag.defaultNote = this.helperService.deepCopy(officeFlag.adminNotes);
      }
      if (this.service?.officeFlag?.adminNotes) {
        this.isHideAdminTextbox = true;
      }

      //get latest date
      if (officeFlag.techUpdatedAt && officeFlag.adminUpdatedAt) {
        if (new Date(officeFlag.techUpdatedAt).getTime() > new Date(officeFlag.adminUpdatedAt).getTime()) {
          this.service.officeFlag.isTechLatest = true;
          this.service.officeFlag.isOfficeLatest = false;
        } else {
          this.service.officeFlag.isTechLatest = false;
          this.service.officeFlag.isOfficeLatest = true;
        }
      } else {
        this.service.officeFlag.isTechLatest = false;
        this.service.officeFlag.isOfficeLatest = true;
      }
    }

    if (!officeFlag?.flagStatus) {
      this.service.isOfficeFlag = true;
      this.isHideAdminTextbox = false;
      this.service.officeFlag = {
        flagStatus: 'active',
      };
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    if (this.isInvalidDragEvent) {
      this.isInvalidDragEvent = false;
      return;
    }

    if (event.previousContainer.id === event.container.id) {
      if (event.currentIndex !== this.service.items.length - 1) {
        moveItemInArray(this.service.items, event.previousIndex, event.currentIndex);
        this.updateService();
      } else if (event.currentIndex === this.service.items.length - 1) {
        moveItemInArray(this.service.items, event.previousIndex, event.currentIndex - 1);
        this.updateService();
      }
    } else {
      if (event.currentIndex !== event.container.data.length) {
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        this.updateService();
      } else if (event.currentIndex === event.container.data.length) {
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex - 1);
        this.updateService();
      }
    }
  }

  onInvalidDragEventMouseDown() {
    this.isInvalidDragEvent = true;
  }

  dragStarted(event) {
    if (this.isInvalidDragEvent) {
      document.dispatchEvent(new Event('mouseup'));
    }
  }

  handleOpenTechDialog() {
    if (this.isArchived) return;
    this.appOpenAssignTechDialog.emit(this.service._id);
  }

  handleFocus(type: string) {
    this.acFocus[type] = true;
    this.errors[type] = '';

    if (type === 'title' && this.service.title && this.service.title.includes('Untitled')) {
      this.service.title = this.service.title.replace(/untitled/i, '').trim();
    }

    if (type === 'notes') {
      this.notesRows = 3;
    }
  }

  handleBlur(type: string) {
    this.acFocus[type] = false;
    this.service.isNew = false;

    // Saving service title
    if (type === 'title') {
      if (this.service.title) {
        if (this.service.title !== this.defaultService.title) {
          this.httpService.updateOrderServiceTitleNotes(this.service._id, this.estimateId, {
            'services.$.title': this.service.title,
            isCalculatedNeeded: false,
          });

          this.defaultService.title = this.service.title;
        }
      } else {
        this.service.title = this.helperService.getLocalizationValue(this.currentLang, this.service, 'title') || 'Untitled';
      }
    }

    // Saving service notes
    if (type === 'notes') {
      if (this.service.notes !== this.defaultService.notes) {
        this.httpService
          .updateOrderServiceTitleNotes(this.service._id, this.estimateId, {
            'services.$.notes': this.service.notes,
            isCalculatedNeeded: false,
          })
          .then((res: any) => {
            if (res && res.message === 'service-inprogress') {
              this.service.notes = res.service.notes;
              this.service.titleUpdatedAt = res.service.titleUpdatedAt;
              this.service.titleUpdatedBy = res.service.titleUpdatedBy;
              this.helperService.showToaster('error', `Can't update notes service is inprogress`);
            }
          });
        this.defaultService.notes = this.service.notes;
      }
    } else if (type === 'notes' && !this.service.notes) {
      this.notesRows = 1;
    }

    if (type === 'title' && !this.service.title) {
      this.errors.title = 'Canned service name is required';
    }
  }

  handleFETFeeUpdate(serviceItem: any) {
    if (serviceItem?.type === 'tire' && serviceItem.fetValue && serviceItem?.itemInternalReference) {
      //service Line update case
      this.service.items.forEach((serviceItemObj: any) => {
        if (serviceItemObj?.associatedItemsInternalReferences?.length && serviceItemObj.isPassThroughFet) {
          serviceItemObj?.associatedItemsInternalReferences.forEach((referenceId: string) => {
            if (referenceId === serviceItem?.itemInternalReference) {
              serviceItemObj.count = serviceItem.count;
              serviceItemObj.defaultCount = serviceItem.count;
            }
          });
        }
      });
    } else if (serviceItem?.type === 'hazmatFee' && serviceItem.isPassThroughFet && serviceItem?.associatedItemsInternalReferences?.length) {
      serviceItem?.associatedItemsInternalReferences?.forEach((value: string) => {
        const index = findIndex(this.service.items, { itemInternalReference: value });
        if (index > -1) {
          this.service.items[index].count = serviceItem.count;
          this.service.items[index].fetValue = serviceItem.price;
          this.service.items[index].defaultCount = serviceItem.count;
        }
      });
    }
  }

  handleOpenItemModal(data: any) {
    this.openItemDialog.emit({ ...data, serviceCardIndex: this.cardIndex });
  }

  handleOnlineOrderingAction(data: any) {
    const payload = { ...data, searchTerm: '' };

    if (!new RegExp('untitled', 'i').test(trim(this.service.title))) {
      payload.searchTerm = this.service.title;
    }
    if (data.partLookTitle) payload.searchTerm = data.partLookTitle
    this.appHandleOnlinOrderAction.emit(payload);
  }

  handleChange(name: string, value: string) {
    this.service[name] = value;
  }

  _updateService() { }

  renderInitials({ firstName, lastName }) {
    return this.helperService.fetchInitials(`${firstName} ${lastName}`);
  }

  deleteService(isForcedDelete: boolean = false) {
    let hasReturns = false;

    if (!isForcedDelete && this.service && this.service.items && this.service.items.length) {
      for (let i = 0; i < this.service.items.length; i++) {
        const { hasCore, hasReturn } = this.service.items[i];

        if (hasCore || hasReturn) {
          hasReturns = true;
          break;
        }
      }
    }

    if (hasReturns) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: `Confirm deletion?`,
          message: 'Deleting this service will also delete any core cost or return associated with any line item in the service.',
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.deleteService(true);
        }

        onClose.unsubscribe();
      });
    } else {
      if (this.dataService.isSubletTrackingEnabled && this.service?.items?.length) {
        const obj = this.checkDeleteSubletValidation();
        if (obj.hasNotDeleteAbleSublets) {
          this.openConfirmationDialogBox(obj);
          return;
        }
      }
      this.serviceDelete.emit(this.service._id);
    }
  }

  checkDeleteSubletValidation(): any {
    let obj: any = {
      hasNotDeleteAbleSublets: false,
      notDeleteAbleItems: [],
      hasDeleteAbleSublets: false,
      subletDeletedItems: [],
    };
    const items = this.service.items.filter((item: any) => item.type === 'sublet');
    if (items && items?.length) {
      let notDeleteAbleItems: any[] = [];
      let subletDeletedItems: string[] = [];
      items.forEach((subletItem: any) => {
        if (subletItem.tags && subletItem.tags?.length) {
          const index = findIndex(subletItem.tags, (tag: any) => {
            return ['Completed', 'Paid'].includes(tag.name);
          });
          if (index > -1) {
            notDeleteAbleItems.push(subletItem);
          } else {
            subletDeletedItems.push(subletItem?.itemInternalReference);
          }
        }
      });

      if (notDeleteAbleItems.length) {
        obj.hasNotDeleteAbleSublets = true;
        notDeleteAbleItems.push({
          title: null,
          type: null,
          isTaxable: false,
          count: '',
          price: null,
          discount: JSON.parse(JSON.stringify(config.estimate.discountType[0])),
          discountAmt: null,
          taxAmt: null,
          subTotal: 0,
          tags: [],
        });
        obj.notDeleteAbleItems = notDeleteAbleItems;
      }

      if (subletDeletedItems.length) {
        obj.hasDeleteAbleSublets = true;
        obj.subletDeletedItems = subletDeletedItems;
      }
    }

    return obj;
  }

  openConfirmationDialogBox(obj: any) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog carfax-customized-confirmation',
      showHeader: false,
      data: {
        isCustomizedConfirmationBox: true,
        isHTML: true,
        styleClassHeading: 'font-18 font-700',
        styleClassCloseIcon: 'font-24 font-400 font-gray',
        title: `Delete ${this.service.title || 'Untitled'}`,
        headerIcon: 'fa fa-exclamation-circle font-icon-warning',
        headerIconType: 'header-icon-warning',
        message: `<span>
          <p>Some of the sublet items will not be deleted since they are marked as completed or paid.</p>
          <p class="mb-0">Do you want to proceed with deleting the rest of the items?</p>
        </span>`,
        button: {
          success: {
            title: `Delete`,
            styleClass: 'btn-primary',
          },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        obj.serviceId = this.service._id;
        this.updateService(obj);
      }
      onClose.unsubscribe();
    });
  }

  handleTechFlag() {
    const ref = this.dialogService.open(TechFlagDialogComponent, {
      width: '755px',
      styleClass: 'add-dialog',
      showHeader: false,
      data: {
        serviceId: this.service._id,
        estimateId: this.estimateId,
      },
    });
    const onClose = ref.onClose.subscribe((isRefetch) => {
      if (isRefetch) {
        this.service.techFlag = isRefetch.techFlag;
        this.createTechFlagTooltip();
      }
      onClose.unsubscribe();
    });
  }

  handleConfirmServiceDelete() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Delete ${this.service.title || 'Untitled'}`,
        message: 'Are you sure you want to delete this service?',
        button: {
          success: { title: 'Delete', backgroundColor: '#d47877' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.deleteService();
      }
      onClose.unsubscribe();
    });
  }

  handleConfirmInspectionDelete({ title, inspectionId }) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        inspectionId,
        styleClassHeading: 'font-14',
        title: `Delete ${title}`,
        message: 'Are you sure you want to remove this inspection?',
        button: {
          success: { title: 'Confirm', backgroundColor: '#d47877' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess && data.inspectionId) {
        this.deleteInspection.emit({
          inspectionId: data.inspectionId,
          serviceId: this.service._id,
        });
      }
      onClose.unsubscribe();
    });
  }

  handleOpenInspectionDialog(inspection: any) {
    this.openInspectionDialog.emit({
      inspectionId: inspection.inspectionId,
      serviceId: this.service._id,
      isAlCertified: this.service?.inspection?.inspectionId?.isAlCertified,
      associatedInspectionId: inspection.associatedInspectionId
    });
  }

  handleBlurAll() {
    for (const property in this.acFocus) {
      if (property) {
        this.acFocus[property] = false;
      }
    }
  }

  handleServiceAction(action) {
    if (action.value === 'RearrangeServices') {
      this.handleEstimateAction.emit(action);
    } else if (action.value === 'viewAsTech') {
      this.navigateToTech();
    } else if (action.value) {
      this.saveAsCannedService();
    }
  }

  handleRepairGuideAction(action: any, service?: any) {
    if ((service.itemSource === '' || service.itemSource === 'Mitchell1') && action.value === 'motor-repair') {
      this.appOpenMotorServiceDialog.emit(service.title);
    } else if (action.value === 'mitchell1-repair') {
      this.handleOpenMitchellInterface();
    } else if (action.value === 'motor-repair') {
      this.openRepairDialogramDialog();
    }
  }

  navigateToTech() {
    if (this.service.tech && this.service.tech.techId) {
      const { emplyeeId } = this.helperService.getCompany();
      if (this.service.tech.techId === emplyeeId || this.service.hTechOne.techId === emplyeeId || this.service.hTechTwo.techId === emplyeeId) {
        this.helperService.openPageInSameTab(`/tech/service/${this.estimateId}/${this.service._id}`, 'set');
      } else {
        this.helperService.showToaster('error', 'You are not assigned to any service in the RO');
        this.handleOpenTechDialog();
      }
    } else {
      this.helperService.showToaster('error', 'You are not assigned to any service in the RO');
      this.handleOpenTechDialog();
    }
  }

  handleInProgressTechChange() {
    this.helperService.showToaster('error', `You can't change technician the service is inprogress`);
  }

  handleTagCreate(tag) {
    this.appTagCreated.emit(tag);
  }

  handleOpenInspection() {
    this.openInspectionImportDialog.emit(this.service._id);
  }

  updateService(payload: any = {}) {
    this.calculateAllTotal.emit(true);
    if (payload && payload.isOpenFromUpdateSupplier) {
      this.appUpdateServiceDirect.emit(payload);
    } else {
      this.appUpdateService.emit(payload);
    }
  }

  selectTechnician(technician: any) {
    const tech = {
      techId: technician._id,
      name: `${technician.firstName || ''} ${technician.lastName || ''}`,
      associatedAt: new Date(),
    };
    this.isAssigningTech = true;
    this.httpService
      .assignTechToService(this.service._id, {
        estimateId: this.estimateId,
        name: tech.name,
        serviceId: this.service._id,
        techId: tech.techId,
        initials: technician.initials,
        title: this.service.title,
        titleFR: this.service.titleFR,
        categoryId: (this.service.category && this.service.category.categoryId) || '',
      })
      .then(
        (res) => {
          this.isAssigningTech = false;
          this.service.tech = tech;
          this.techAssignSuccess.emit(true);
        },
        (err) => {
          this.isAssigningTech = false;
          this.helperService.showToaster('error', err);
        }
      );
  }

  itemDelete(index: any, isForcedDelete: boolean = false, isFromFETSection: boolean = false) {
    const serviceItem: any = this.service.items[index] || {};

    if (this.dataService.isTireStorage2Enabled && serviceItem.type === 'tireStorage') {
      if (serviceItem.associatedInspection && serviceItem.associatedInspection.inspectionId && `${this.service.inspection?.inspectionId?.associatedInspectionId}` === `${serviceItem.associatedInspection.inspectionId}`) {
        this.deleteInspection.emit({
          inspectionId: serviceItem.associatedInspection.inspectionId?._id || serviceItem.associatedInspection.inspectionId,
          serviceId: this.service._id,
        });
      }
    }
    if (!isForcedDelete && (serviceItem.hasReturn || serviceItem.hasCore)) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: `Confirm deletion?`,
          message: 'Deleting this line item will also delete any core cost or return associated with the line.',
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.itemDelete(index, true);

          if (serviceItem) {
            this.generateDeleteItemLog(serviceItem);
          }

          this.httpService.deleteAdHoc({ orderId: this.estimateId, orderServiceItemId: serviceItem._id }).then(
            (res) => {
              this.helperService.showToaster('success', 'Successfully deleted');
            },
            (err) => {
              console.log(err);
            }
          );
        }

        onClose.unsubscribe();
      });
    } else {

      if (!isFromFETSection && this.dataService.isQTQAddOnEnable && this.dataService.isPassThroughTaxEnable && serviceItem?.type === 'tire' && serviceItem?.itemInternalReference) {
        let associatedFETfeeIndex: number = -1;
        let isReferenceFound: boolean = false;
        this.service.items.forEach((item: any, itemIndex: number) => {
          if (item?.associatedItemsInternalReferences?.length && item?.type === 'hazmatFee' && item?.isPassThroughFet) {
            if (isReferenceFound) {
              return;
            }
            item?.associatedItemsInternalReferences.forEach((value: string) => {
              if (!isReferenceFound && value === serviceItem?.itemInternalReference) {
                isReferenceFound = true;
                associatedFETfeeIndex = itemIndex;
              }
            });
          }
        });
        if (associatedFETfeeIndex > -1) {
          const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
            width: '30%',
            styleClass: 'small-heading-dialog',
            showHeader: false,
            data: {
              styleClassHeading: 'font-14',
              title: `Confirm deletion?`,
              message: 'Deleting this line item will also delete any associated FET with the line',
              button: {
                success: { title: 'Confirm' },
                cancel: { title: 'Cancel' },
              },
            },
          });

          const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
            if (isSuccess) {
              const associatedFETItem = this.service.items[associatedFETfeeIndex];
              this.service.items.splice(associatedFETfeeIndex, 1);
              this.itemDelete(index, true, true);
              this.generateDeleteItemLog(associatedFETItem);

            }

            onClose.unsubscribe();
          });

        } else {
          this.itemDelete(index, true, true);
        }
      } else {
        this.service.items.splice(index, 1);
        //added to avoid generate activity log in case of creating new catalouge item from service line
        if(serviceItem?.title || serviceItem?.titleFR) {
          this.generateDeleteItemLog(serviceItem);
        }

        if (this.service.items.length === 0) {
          this.service.items.push({
            title: null,
            type: null,
            isTaxable: false,
            count: '',
            price: null,
            discount: JSON.parse(JSON.stringify(config.estimate.discountType[0])),
            discountAmt: null,
            taxAmt: null,
            subTotal: 0,
            tags: [],
          });
        }

        this.service = { ...this.service };
        if (serviceItem?.type === 'sublet' && this.dataService.isSubletTrackingEnabled) {
          this.updateService({ subletDeletedItems: [serviceItem.itemInternalReference], hasDeleteAbleSublets: true, serviceId: this.service._id });
        } else {
          this.updateService();
        }
      }

    }
  }

  generateDeleteItemLog(serviceItem: any) {
    this._generateActivity({
      entityId: this.service._id,
      entityType: 'service',
      entityAction: 'updated',
      activityData: {
        type: 'plaintext',
        icon: this.icons[serviceItem.type],
      },
      isPrimary: false,
      title: `${this.labels[serviceItem.type]} removed`,
      text: `RO# ${this.estimateCode}: ${this.labels[serviceItem.type]} (${serviceItem.title || serviceItem?.titleFR}) of value ${this.currencyPipe.transform(
        Number(serviceItem.netSubTotal || 0)
      )} was removed from the Service "${this.serviceTitle}"`,
    });
  }

  addRow({ index, type, isFocusTitle, itemData = null }) {
    const item = {
      title: null,
      type: null,
      isTaxable: false,
      count: '',
      price: null,
      discount: this.helperService.deepCopy(config.estimate.discountType[0]),
      discountAmt: null,
      taxAmt: null,
      subTotal: 0,
      tags: [],
      isFocusTitle,
      invalid: false,
      itemData,
      subItems: [],
    };

    if (isNaN(index) && !type) {
      this.service.items.push(item);
    } else {
      item.type = type;
      this.service.items.splice(index, 0, item);
    }

    this.calculateAllTotal.emit(true);
  }

  insertServiceItem({ index, item = null }) {
    this.service.items.splice(index, 0, item);
    this.calculateTotal();
  }

  onClickedOutsideCard() {
    this.closeAllItem = Math.random();
  }

  calculateTotal() {
    this.calculateAllTotal.emit(true);
  }

  includeInvoiceChange(event: any) {
    this.service.includeInInvoice = event;
    this.calculateAllTotal.emit(true);
    this.appUpdateService.emit();
  }

  handleRecommentedServiceUpdate(event: any) {
    this.service.isRecommended = event;

    this.httpService.updateOrderServiceTitleNotes(this.service._id, this.estimateId, {
      'services.$.isRecommended': this.service.isRecommended,
      isCalculatedNeeded: false,
    });
    this.calculateAllTotal.emit(true);
    this.appUpdateService.emit();
  }

  saveAsCannedService() {
    if (!this.service.title) {
      this.helperService.showToaster('error', 'Please provide service title');
    } else {
      /**
       * This data is subscribe in header.component
       */
      const serviceData = this.helperService.deepCopy(this.service);
      delete serviceData._id;

      // this.dataService.sendData(this.dataService.typeDialog('add-canned', 'service-card', null, null, serviceData));
      this.dialogService.open(CannedServiceDialogComponent, {
        width: '970px',
        styleClass: 'add-dialog canned-service-dialog',
        showHeader: false,
        data: { ...serviceData, currentLang: this.currentLang },
      });
    }
  }

  _generateActivity(data: any) {
    if(data?.title != "undefined description updated") {
      this.generateActivity.emit(data);
    }
  }

  _updateTags(data) {
    if (data.current && data.previous) {
      this.service.items.forEach((item: any) => {
        if (item.tags && item.tags.length) {
          for (let i = 0; i < item.tags.length; i++) {
            if (item.tags[i].name === data.previous.name) {
              item.tags[i].name = data.previous.name;
              item.tags[i].color = data.previous.color;
              break;
            }
          }
        }
      });
    }
    this.updateTags.emit(data);
  }

  openRO(estimateId: string) {
    if (!estimateId) return;

    this.helperService.openPageInNewExistingTab(`/estimate/${estimateId}`, estimateId);
  }

  handlePartAddInventoryDialog(item: any) {
    if (['part', 'tire'].includes(item.type) && !['PartsTech', 'Nexpart'].includes(item.itemSource)) {
      const ref = this.dialogService.open(PartAddInventoryDialogComponent, {
        width: '970px',
        styleClass: `add-dialog add-to-inventory-dialog`,
        showHeader: false,
        data: {
          ...item,
          orderCode: this.estimateCode,
          orderId: this.estimateId,
        },
      });
      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        onClose.unsubscribe();
      });
    }
  }

  handlePartAndCoreReturnDialog(item: any) {
    if (this.isManualPartOrderingEnabled && item.isOrderExist && ['part', 'tire'].includes(item.type) && item.returnType === 'item') {
      this.handleManualOrderPartReturnToSupplierAndCoreDialog(item);
    } else {
      this.handleCoreAndTireReturnDialog(item);
    }
  }

  handleCoreAndTireReturnDialog(item: any) {
    if (['PartsTech', 'Nexpart'].includes(item.itemSource) && item.orderItemId && this.isPartOrderingOrdered({ orderItemId: item.orderItemId, itemSource: item.itemSource })) {
      this.helperService.showToaster('error', 'This part has not been ordered yet');
      return;
    }

    const poNumber = this.getPartsOrderingPONumber({ itemSource: item.itemSource, orderItemId: item.orderItemId });
    if (item.type === 'part' && !item?.supplier?.name) {
      this.helperService.showToaster('error', 'Please assign a supplier to this item before adding Core');
      return;
    }
    const component = item.type === 'part' ? CoreAndPartReturnDialogComponent : CoreAndTireReturnDialogComponent;
    const ref = this.dialogService.open(component, {
      width: '970px',
      styleClass: `add-dialog item-dialog ${item.type}`,
      showHeader: false,
      data: {
        ...item,
        poNumber,
        orderCode: this.estimateCode,
        orderId: this.estimateId,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      this.setReturnCoreTags(data);
      onClose.unsubscribe();
    });
  }

  handleManualOrderPartReturnToSupplierAndCoreDialog(item: any) {
    const ref = this.dialogService.open(PartAddInventoryDialogComponent, {
      width: '970px',
      styleClass: `add-dialog add-to-inventory-dialog`,
      showHeader: false,
      data: {
        dialogType: 'return',
        orderId: this.estimateId,
        actualItem: { ...item },
        associatedItem: { ...item },
      },
    });
    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.getEstimatesById.emit();
      }
      onClose.unsubscribe();
    });
  }

  handleOpenCatalogueDialog(item: any) {
    const ref = this.dialogService.open(CatalogueDialogComponent, {
      width: '520px',
      styleClass: `add-dialog item-dialog add-inventory`,
      showHeader: false,
      data: {
        orderId: this.estimateId,
        item: { ...item },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data, onlineItem }) => {
      if (isSuccess) {
        for (let i = 0; i < this.service.items.length; i++) {
          const item = this.service.items[i];

          if (item.orderItemId === onlineItem.orderItemId) {
            data.openItemDialog = true;
            if (onlineItem && onlineItem.isOpenFromUpdateSupplier) {
              data.isOpenFromUpdateSupplier = true;
            }
            this.service.items[i].itemData = data;
            this.cdr.detectChanges();
            this.helperService.showToaster('success', `${onlineItem.title} dissociated from ${onlineItem.itemSource}`);

            if (item && item.isOpenFromInventory) {
              this.calculateAllTotal.emit(true);
              this.appUpdateService.emit(true);
            } else if (onlineItem && !onlineItem.isOpenFromUpdateSupplier) {
              this.getEstimatesById.emit();
            }
          }
        }
      }

      onClose.unsubscribe();
    });
  }

  setReturnCoreTags = (data: any) => {
    if (data._id) {
      for (let i = 0; i < this.service.items.length; i++) {
        const item = this.service.items[i];

        if (item._id === data.orderServiceItemId) {
          item.coreCost = data.coreCost;
          item.qtyReturn = data.itemReturnQty;
          item.hasCore = !!data.coreCost;
          item.hasReturn = !!data.itemReturnQty;
          item.orderServiceItemId = data.orderServiceItemId;
          item.orderItemId = data.orderItemId;
          item.coreRetrievalStatus = data.coreRetrievalStatus;

          // if (item.tags) {
          //   item.tags = item.tags.filter(({ name }) => !['Core', 'Returned'].includes(name));
          // }

          // if (item.hasCore) {
          //   const coreTag = find(this.serviceTags, { name: 'Core' });
          //   coreTag.tooltip = `Core: $${Number(item.coreCost).toFixed(2)}`;
          //   if (coreTag) item.tags.push(coreTag);
          // }

          // if (item.hasReturn) {
          //   const returnTag = find(this.serviceTags, { name: 'Returned' });
          //   returnTag.tooltip = `Qty returned: ${Number(item.qtyReturn)}`;
          //   if (returnTag) item.tags.push(returnTag);
          // }

          const { orderItemId, coreRetrievalStatus, itemSource, orderServiceItemId, itemReturnQty } = item;

          if (['PartsTech', 'Nexpart'].includes(itemSource)) {
            this.adHocMap[orderItemId] = { itemReturnQty, coreStatus: coreAndReturnMap[coreRetrievalStatus] };
          } else {
            this.adHocMap[orderServiceItemId] = { itemReturnQty, coreStatus: coreAndReturnMap[coreRetrievalStatus] };
          }

          this.adHocMap = { ...this.adHocMap };
        }
      }

      this.service = { ...this.service };
      this.updateService({ replaceService: true });
    }
  };

  openRepairDialogramDialog() {
    this.openRepairDialogram.emit({
      applicationId: this.service.itemSourceId,
      displayName: this.service.title,
    });
  }
  // added isAddItemNeeded as part of fixing ALP-8034
  fetchAndSelectAttachedItems({ itemId, itemInternalReference, isAddItemNeeded = true, isAdding = false }) {
    this.httpService.getItemById(itemId).then(
      (data: any) => {
        if (data.associatedItems && data.associatedItems.length) {
          data.associatedItems.forEach(({ itemId: item }) => {

            if (item?.type === 'hazmatFee' && item?.isPassThroughFet) {
              this.service.items?.forEach((serviceItem: any) => {
                if (serviceItem.type === 'tire' && serviceItem.associatedItems?.length) {
                  const fetFeeAssociatedIndex = findIndex(serviceItem.associatedItems, { itemId: item._id });
                  if (fetFeeAssociatedIndex > -1) {
                    //override the price and cost with defined fetValue in case of FET fee
                    item.count = serviceItem.count;
                    item.price = serviceItem?.fetValue;
                    item.cost = serviceItem?.fetValue || 0;
                  }
                }
              })
            }


            data.itemInternalReference = itemInternalReference;
            const counts = this.countOfItemsExistsInFees({ actualItem: data, isAdding, associatedItems: (item.associatedItems || []).map(({ itemId }) => itemId) });

            item.associatedItemsInternalReferences = counts.itemIds;
            item.count = counts.count;

            if (item?._id && item?.status) {
              const isFeesAdded = isAdding && item.type === 'hazmatFee';
              if (!isFeesAdded && this.isItemAlreadyExists({ type: item.type, itemId: item._id })) {
                // added associatedItemCounts as prt of fixing ALp-8033
                this.updateItemPriceAndCount.emit({
                  itemId: item._id,
                  count: counts.count,
                  itemInternalReference,
                  associatedItemCounts: counts,
                });
              } else {
                delete item.associatedItems;

                if (item.feeValueType === 'percent') {
                  item.pricePercent = item.price;
                  item.costPercent = item.cost;
                  item.price = counts.price * (item.price / 100);
                  item.cost = counts.cost * (item.cost / 100);
                }

                item.autoAdded = true;

                this.addRow({ index: this.service.items.length - 1, type: item.type, isFocusTitle: false, itemData: item });
              }
            }
          });
          if (isAddItemNeeded) {
            this.addRow({ index: this.service.items.length, type: '', isFocusTitle: true });
          }
        } else {
          if (isAddItemNeeded) {
            this.addRow({ index: this.service.items.length, type: '', isFocusTitle: true });
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  async getAndSelectBundleItem({ itemId, index }) {
    try {
      const itemSourceId = Date.now();
      const flatRate: any = await this.httpService.getItemById(itemId, { populateSubItems: true });

      if (flatRate) {
        flatRate.itemSourceId = itemSourceId;
        flatRate.flatRate = flatRate.flatRate;
        flatRate.subTotal = flatRate.flatRate;
        flatRate.netSubTotal = flatRate.flatRate;
        flatRate.cost = flatRate.cost;
        flatRate.price = flatRate.flatRate;
        flatRate.description = flatRate.description;
      }

      if (this.service.items[index] && this.service.items[index].type === 'bundle') {
        this.service.items.splice(index, 1);
      }

      flatRate.subItems = flatRate.subItems.map((item: any) => {
        const subItem = { ...item.itemId };

        subItem.itemSourceId = itemSourceId;
        subItem.isTaxable = item.isTaxable;
        subItem.cost = item.cost;
        subItem.price = item.price;
        subItem.netPrice = item.netPrice;
        subItem.count = item.count;
        subItem.flatRateAmount = item.flatRateAmount;
        subItem.subTotal = item.flatRateAmount;
        subItem.netSubtotal = item.flatRateAmount;
        subItem.actualLaborTime = item.actualLaborTime;
        subItem.costEstimatedHours = item.costEstimatedHours;
        subItem.commissionable = item.commissionable;
        subItem.supplier = item.supplier;
        subItem.itemId = item.itemId._id;
        subItem.flatRateId = flatRate._id;
        subItem.isFlatRateSubItem = true;
        subItem.displayDescOnOrder = item.displayDescOnOrder;
        subItem.displayHoursOnOrder = item.displayHoursOnOrder;
        subItem.description = item.description;
        subItem.isPassThroughTax = item.isPassThroughTax;

        return subItem;
      });

      this.addRow({ index: this.service.items.length - 1, type: flatRate.type, isFocusTitle: false, itemData: flatRate });
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  createTechFlagTooltip() {
    let tooltip = ``;

    const { techFlag, techUpdatedAt, adminUpdatedAt } = this.service;
    tooltip += `
        <div class="tooltip-2">
        <div class="tooltip-body">
          <div class="tooltip-body-header">
            <i class="fal fa-tools mt-1"></i>
            <span>${this.service.title}</span>
          </div>

          <div class="tooltip-body-box">
            <div class="row tooltip-body-row">
              <div class="col-6 p-0 tooltip-body-box-left">
                <div class="tooltip-body-box-header">
                  <i class="fal fa-comment-exclamation mt-1"></i>
                  <div class="tooltip-info-box"  >
                    <p class="tech-name">${techFlag.techName || ''}</p>
                    <p class="date">${techUpdatedAt ? 'Last updated' : ''} ${techUpdatedAt || ''}</p>
                    <p class="description font-12 five-line-elipsis" style="font-size: 12px !important;">
                    ${techFlag.techNotes || ''}
                    </p>
                  </div>
                </div>
              </div>

              ${!techFlag.adminId
        ? `
                  <div class="col-6 p-0 tooltip-body-box-right">
                    <div class="tooltip-body-box-header h-100">
                      <i class="fal fa-comment-lines"></i>
                      <div class="tooltip-info-box flex-center-center tech-flag-empty-state h-100">
                        <span class="font-gray-45">Flag has no replies</span>
                      </div>
                    </div>
                  </div>
                `
        : `
                <div class="col-6 p-0 tooltip-body-box-right">
                  <div class="tooltip-body-box-header">
                    <i class="fal fa-comment-lines"></i>
                    <div class="tooltip-info-box">
                      <p class="tech-name">${techFlag.adminName}</p>
                      <p class="date">Last updated ${adminUpdatedAt}</p>
                      <p class="description font-12 five-line-elipsis" style="font-size: 12px !important;">
                      ${techFlag.adminNotes}
                      </p>
                    </div>
                  </div>
                </div>
              `
      }

            </div>
          </div>
        </div>
      </div>
        `;

    return `<div class="tooltip-seondary tooltip-wrapper">
              <div class="tooltip-secondary-row tooltip-header divider-bottom">
                <i class="fas fa-flag ${techFlag.flagStatus === 'open' ? 'font-red' : 'font-gray-55'}"></i>Flag notes
              </div>
              ${tooltip}
            </div>`;
  }

  getRepairGuideOptions() {
    // const repairGuideOptions = [];
    // if (this.service.itemSource === 'Motor' && this.isRepairDiagramEnabled) {
    //   repairGuideOptions.push(this.motorGuideOption);
    // }
    // if (['Motor', 'Mitchell1'].includes(this.service.itemSource) && this.isMitchellIntegrationEnabled) {
    //   repairGuideOptions.push(this.mitchell1GuideOption);
    // }
    // return [...repairGuideOptions];
    const repairGuideOptions = [];
    if (this.isRepairDiagramEnabled) {
      repairGuideOptions.push(this.serviceTitleIcons.Motor);
    }
    if (this.isMitchellIntegrationEnabled) {
      repairGuideOptions.push(this.serviceTitleIcons.Mitchell1);
    }
    return [...repairGuideOptions];
  }

  serviceAccordion() {
    this.isServiceCollapse = !this.isServiceCollapse;
    const data = {
      isCollapse: this.isServiceCollapse,
      serviceIndex: this.cardIndex,
    };
    this.isServicesAOpen.emit(data);
  }

  onEditingServiceItem(event: any) {
    const data = {
      isCollapse: !event?.isEditing,
      serviceIndex: this.cardIndex,
    };
    this.isServicesAOpen.emit(data);
  }

  removedPartsLookupAndReplaceAction(event: any) {
    this.removedPartsLookupAndReplace.emit({
      serviceIndex: event.serviceIndex,
      itemIndex: event.itemIndex,
      data: event.data,
      isFlatRateSubItem: event.isFlatRateSubItem,
    })
  }

  appOpenVehicleAction(event: any) {
    this.appOpenVehicleActionModal.emit(event);
  }

  subItemFilter(items: any[]): any[] {
    return items;
  }

  emitCostUpdated(event: any) {
    this.appEmitCostUpdated.emit(event);
  }

  handleOpenNotesTab(type) {
    if (this.isArchived && !this.isFinalizedRo) return;
    const data = {
      type: 'orderServiceNote',
      notes: this.service.notes,
      serviceId: this.service._id,
      sideModalStyleClass: 'side-panel-notes',
      title: this.service.title,
      isFinalizedRo: this.isFinalizedRo
    };
    this.dataService.sendData(this.dataService.typeSidebar('sidebar-notes', type, type, data));
  }

  handleOpenMitchellInterface() {
    this.appHandleOpenMitchellInterface.emit(this.service.title);
  }

  toggleTechCard(techId, cardId) {
    if (this.isArchivedRO) return;
    this.techID = techId;
    if (this.isTechCardOpen) {
      this.cardId = cardId;
      this.isTechnicianDetailsVisible = true;

      this.fetchTechDetails(techId);
      this.setTechCardInterval(techId);
    } else {
      if (this.isTechnicianDetailsVisible) {
        this.isTechnicianDetailsVisible = !this.isTechnicianDetailsVisible;
        if (this.interval) {
          clearInterval(this.interval);
        }
        this.employee = {};
        this.currentService = {};
        this.inProgressService = {};
        this.timeAllocated = '';
        this.timeSpent = '';
        this.cardId = '';
      } else {
        this.cardId = cardId;
        this.isTechnicianDetailsVisible = !this.isTechnicianDetailsVisible;
        this.fetchTechDetails(techId);
        this.setTechCardInterval(techId);
      }
    }
  }

  setTechCardInterval(techId) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      if (this.isTechnicianDetailsVisible) {
        this.getTechDetails(techId);
      }
    }, 60000);
  }

  getTechDetails(techid) {
    const data = {
      serviceId: this.service._id,
      orderId: this.estimateId,
      employeeId: techid,
    };
    if (!data.employeeId) {
      return;
    }
    this.httpService.getTechDetails(this.estimateId, data).then(
      (res: any) => {
        const { inProgressService, currentService, employee, totalTimeSpent } = res;
        this.inProgressService = inProgressService;
        this.currentService = currentService;
        this.employee = employee;
        this.totalTimeSpent = totalTimeSpent;
        this.setAllocatedTime();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  // FETCHING TECH DETAILS
  fetchTechDetails(techid) {
    this.isProcessing = true;
    const data = {
      serviceId: this.service._id,
      orderId: this.estimateId,
      employeeId: techid,
    };

    if (!data.employeeId) {
      return;
    }

    this.httpService.getTechDetails(this.estimateId, data).then(
      (res: any) => {
        this.isProcessing = false;
        const { inProgressService, currentService, employee, totalTimeSpent } = res;
        this.inProgressService = inProgressService;
        this.currentService = currentService;
        this.employee = employee;
        this.totalTimeSpent = totalTimeSpent;
        this.isTechCardOpen = false;
        this.setAllocatedTime();
      },
      (err) => {
        this.isProcessing = false;
        console.log(err);
      }
    );
  }

  setAllocatedTime() {
    if (this.isBillableHoursEnabled && this.service.billableHours) {
      this.timeAllocatedMin = 0;
      this.timeAllocatedMin = this.service.billableHours * 60;
    } else if (!this.isBillableHoursEnabled) {
      if (this.service && this.service.items) {
        this.costEstimatedHour = 0;
        this.service.items.forEach((item) => {
          if (item.type === 'labor') {
            this.costEstimatedHour += item.costEstimatedHours;
            this.timeAllocatedMin = round(this.costEstimatedHour * 60);
            //ALP-8452 -- start fix -- Service time not showing for flat rate items on techapp
            if (item.subItems) {
              item.subItems.forEach((subItem: any) => {
                if (subItem.type === 'labor') {
                  this.costEstimatedHour += subItem.costEstimatedHours;
                  this.timeAllocatedMin = round(this.costEstimatedHour * 60);
                }
              });
            }
          } else if (item.type === 'bundle' && item?.subItems?.length) { //Adding the flat rate in count the labor hours against ALP-20807
            item.subItems.forEach((subItem: any) => {
              if (subItem.type === 'labor') {
                this.costEstimatedHour += subItem.costEstimatedHours;
                this.timeAllocatedMin = round(this.costEstimatedHour * 60);
              }
            });
          }
        });
      }
    }
    const ahours = Math.floor(this.timeAllocatedMin / 60);
    const amins = round((this.timeAllocatedMin % 60), 2);
    const shours = Math.floor(this.totalTimeSpent / 60);
    let smins = round((this.totalTimeSpent % 60), 2);

    this.timeAllocated = `${ahours > 9 ? ahours : `0${ahours || 0}`}:${amins > 9 ? amins : `0${amins || 0}`}`;
    /*
    Change has been done against ALP-20891
      for minutes if we are getting the 2.76 minutes as per the data we are currently showing in attendace log reort 
      its considered as 3 mins since 2.76 decimal value which
      is equivalent to 2min + 76seconds = 2*60 = 120 + 76 = 196 seconds and we only showing the minutes then its should be floored to Floor(196/60) = 3
      
    */
    const sSecArray = toString(smins.toFixed(2))?.split('.');
    if(sSecArray?.length > 1) {
      let  totalSeconds = (Number(sSecArray[0]) * 60) + (Number(sSecArray[1]));
      const totalMins = Math.floor(totalSeconds / 60);
      smins = totalMins;
    }
    this.timeSpent = `${shours > 9 ? shours : `0${shours}`}:${smins > 9 ? smins : `0${smins}`}`?.split('.')[0];

  }

  /** CHECKING THE CLOCKI-IN/CLOCK-OUT STATUS   */

  techServiceAction(service: any, status) {
    const assignableTechId = service?.[this.cardId]?.techId;
    const isTechServiceInProgress =
      (this.inProgressService?.service?.hTechOne?.workStatus === 'inprogress' && assignableTechId === this.inProgressService?.service?.hTechOne?.techId)
      || (this.inProgressService?.service?.hTechTwo?.workStatus === 'inprogress' && assignableTechId === this.inProgressService?.service?.hTechTwo?.techId)
      || (this.inProgressService?.service?.tech?.workStatus === 'inprogress' && assignableTechId === this.inProgressService?.service?.tech?.techId);

    if (service?.[this.cardId]?.workStatus === 'new' || service?.[this.cardId]?.workStatus === 'completed' || service?.[this.cardId]?.workStatus === 'pause') {
      // OUT OF SHOP
      if (!this.employee.clockedIn) {
        const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
          width: '30%',
          styleClass: 'small-heading-dialog',
          showHeader: false,
          data: {
            styleClassHeading: 'font-14',
            message: 'Tech is currently out of shop, would you like to clock them in?',
            button: {
              success: { title: 'Confirm' },
              cancel: { title: 'Cancel' },
            },
          },
        });
        const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
          if (isSuccess) {
            this.updateClockStatus(service, status);
          }
          onClose.unsubscribe();
        });
        // } else if (this.employee.clockedIn && (this.currentService?.service?.[this.cardId]?.workStatus === 'inprogress' || this.inProgressService?.service?.[this.cardId]?.workStatus === 'inprogress')) {
      } else if (this.employee.clockedIn && isTechServiceInProgress) {
        // WORKING
        const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
          width: '30%',
          styleClass: 'small-heading-dialog',
          showHeader: false,
          data: {
            styleClassHeading: 'font-14',
            message: 'Tech is currently working on another service; starting this service will pause the one in-progress. Would you like to continue?',
            button: {
              success: { title: 'Confirm' },
              cancel: { title: 'Cancel' },
            },
          },
        });
        const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
          if (isSuccess) {
            this.handleActionService(service, status);
          }
          onClose.unsubscribe();
        });
      } else if (this.employee?.clockedIn && this.inProgressService.length === 0) {
        // IDLE
        this.handleActionService(service, status);
      } else {
        this.handleActionService(service, status);
      }
    } else {
      this.handleActionService(service, status);
    }
  }

  /** START/ RESUME/ PAUSE/ COMPLETE/ RESTART API CALL  */
  handleActionService(service: any, status) {
    this.data = {
      estimateId: this.estimateId,
      status: status,
      forceClockIn: true,
      override: true,
      forceStart: true,
      title: service.title,
      workId: this.service._id,
      workType: 'service',
      techId: this.cardId === 'tech' ? service.tech.techId : this.cardId === 'hTechOne' ? service.hTechOne.techId : this.cardId === 'hTechTwo' ? service.hTechTwo.techId : service.tech.techId,
    };
    status === 'pause' ? (this.isLoading = true) : (this.isProcessing = true);

    this.httpService.techServiceAction(this.estimateId, this.data).then(
      (res: any) => {
        if (res && res.msg === 'no-vin') {
          if (this.enableMandatoryVin || this.isMileageMandatory) {
            this.isProcessing = false;
            this.dataService.sendData(
              this.dataService.typePassData('no-vin-found', {
                payload: { data: this.data },
                vehicle: res.vehicle,
                customer: res.customer,
                required: res.required,
              })
            );
          }
          return;
        }
        const data = {
          serviceId: this.service._id,
          orderId: this.estimateId,
          employeeId: this.service[this.cardId].techId,
        };

        if (!data.employeeId) {
          return;
        }

        this.httpService.getTechDetails(this.estimateId, data).then(
          (res: any) => {
            const { inProgressService, currentService, employee, totalTimeSpent } = res;
            this.inProgressService = inProgressService;
            this.currentService = currentService;
            this.employee = employee;
            this.totalTimeSpent = totalTimeSpent;
            status === 'pause' ? (this.isLoading = false) : (this.isProcessing = false);
            this.setAllocatedTime();
            if(currentService?.service && currentService?.service?._id === this.service?._id) {
              this.service.tech.workStatus = currentService?.service?.tech && currentService?.service?.tech?.workStatus;
              this.service.hTechTwo.workStatus = currentService?.service?.hTechTwo && currentService?.service?.hTechTwo?.workStatus;
              this.service.hTechOne.workStatus = currentService?.service?.hTechOne && currentService?.service?.hTechOne?.workStatus;
              this.dataService.sendData(this.dataService.typePassData('re-evaluate-labor-summary', currentService?.service));
            }
          },
          (err) => {
            this.isProcessing = false;
            this.helperService.showToaster('error', err);
          }
        );
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  /** UPDATING THE TECH CLOCK-STATUS  */
  updateClockStatus(service: any, status) {
    if (this.isProcessing) {
      return;
    }

    const techData = {
      isClockIn: true,
      forceUpdate: false,
      serviceId: this.service._id,
      orderId: this.estimateId,
    };

    if (!this.employee.clockedIn) {
      techData['techId'] = this.techID;
    }

    this.httpService.updateClockStatus(techData).then(
      (res: any) => {
        if (res.isAlreadyUpdated) {
          this.helperService.showToaster('error', res.message);
        } else if (res.employee.clockedIn) {
          this.handleActionService(service, status);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  openService(techId) {
    if (this.inProgressService.orderId !== this.currentService.orderId) {
      const data = { serviceId: this.inProgressService.service._id, orderId: this.inProgressService.orderId, isScroll: true, techId: techId };
      localStorage.setItem('showTechCard', JSON.stringify(data));
      this.helperService.openPageInNewExistingTab(`/estimate/${this.inProgressService.orderId}`, this.inProgressService.orderId);
    } else {
      this.isTechnicianDetailsVisible = false;
      this.openTechDetailCard.emit({ serviceId: this.inProgressService.service._id, techId: techId });
    }
  }

  async openTechDetails(id) {
    this.currentDateTime = await this.httpService.getServerTime();
    const dateToPass = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(this.currentDateTime), datetimeFormat.yyymmdd);
    const url = `/reports/technician-attendance-log-details/${dateToPass}/${dateToPass}/${id}`;
    this.helperService.openPageInNewTab(url);
  }

  refetchPartsOrderingCart() {
    this.getEstimatesById.emit();
  }

  handleFlagChange(value) {
    this.service.techFlag.adminNotes = value;
  }

  handleOfficeFlagChange(value) {
    this.flagNote = value;
  }

  updatePlaceholderColor() {
    const defaultStyle = 'pb-1 font-600 pl-1';
    return `${defaultStyle} + ${!this.service?.techFlag?.adminNotes && ' secondary-15'}`;
  }

  updateTechPlaceholderColor() {
    const defaultStyle = 'pb-1 font-600 pl-1';
    return `${defaultStyle} + ${!this.flagNote && ' secondary-15'}`;
  }

  handleEditNote() {
    if (!this.isFinalizedRo) {
      this.isHideTechTextbox = false;
    }
  }

  handleEditUserNote() {
    if (!this.isFinalizedRo) {
      this.isHideAdminTextbox = false;
    }
  }

  handleCreateFlag() {
    this.isHideTechTextbox = true;
    this.handleResolvedFlag(this.techFlagStatus, true);
  }

  handleCreateOfficeFlag() {
    this.isHideAdminTextbox = true;
    this.handleResolvedOfficeFlag(this.officeFlagStatus, true);
  }

  handleResolvedFlag(type: string = '', isCreatedNotes = false) {
    if (!this.isFinalizedRo) {
      this.isHideTechTextbox = true;
      if (type === 'open') {
        if (this.service?.techFlag?.adminNotes) {
          this.isHideTechTextbox = true;
        } else {
          this.isHideTechTextbox = false;
        }
      }

      this.techFlagStatus = type;
      let flag = {
        notes: this.service.techFlag.adminNotes,
        flagStatus: this.techFlagStatus,
        action: type === 'open' ? 'reopen' : null,
      };

      if (!this.service?.techFlag?.techNotes) {
        flag.flagStatus = 'open';
      } else if (this.service.techFlag.flagStatus === 'resolved' && this.service.isTechFlag) {
        flag.flagStatus = 'reopen';
      } else if (isCreatedNotes && this.service.isTechFlag) {
        flag.flagStatus = 'updateOnly';
      } else if (flag.flagStatus === 'resolved') {
        flag.flagStatus = 'resolved';
      }

      this.httpService.updateTechFlag(this.estimateId, this.service._id, flag, 'admin').then(
        (estimate: any) => {
          // this.service = estimate.service;
          this.updateServiceFlags(estimate);
          this.setTechFlag();
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  handleResolvedOfficeFlag(type: string = '', isCreatedNotes = false) {
    if (!this.isFinalizedRo) {
      this.isHideAdminTextbox = true;
      if (type === 'open') {
        if (this.service?.techFlag?.adminNotes) {
          this.isHideAdminTextbox = true;
        } else {
          this.isHideAdminTextbox = false;
        }
      }

      this.officeFlagStatus = type;
      const flag = {
        notes: this.flagNote,
        flagStatus: this.officeFlagStatus || 'open',
        action: type === 'open' ? 'reopen' : null,
      };

      if (!this.service?.officeFlag?.adminNotes) {
        flag.flagStatus = 'open';
      } else if (this.service.officeFlag.flagStatus === 'resolved' && this.service.isOfficeFlag) {
        flag.flagStatus = 'reopen';
      } else if (isCreatedNotes) {
        flag.flagStatus = 'updateOnly';
      } else if (flag.flagStatus === 'resolved') {
        flag.flagStatus = 'resolved';
      }

      this.httpService.updateOfficeFlag(this.estimateId, this.service._id, flag, 'admin').then(
        (estimate: any) => {
          // this.service = estimate.service;
          this.updateServiceFlags(estimate);
          this.setOfficeFlag();
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  handleAddServiceNote() {
    if (!this.isFinalizedRo) {
      this.isAddUserResponse = true;
      if (this.isHideTechTextbox) {
        this.isHideTechTextbox = false;
      }
    }
  }

  handleDiscardTechNote() {
    if (this.service?.techFlag?.flagStatus !== 'resolved') {
      this.service.techFlag.adminNotes = this.service?.techFlag?.defaultNote;
      this.isHideTechTextbox = true;
      if (!this.service.techFlag.adminNotes) {
        this.isAddUserResponse = false;
      }
    } else {
      this.service.techFlag.adminNotes = null;
    }
  }

  handleDiscardOfficeNote() {
    if (this.service?.officeFlag?.flagStatus === 'open') {
      this.flagNote = this.service?.officeFlag?.defaultNote;
      this.isHideAdminTextbox = true;
    } else {
      this.flagNote = null;
    }
  }

  openAdminFlagNotes() {
    const flag = {
      viewed: true,
    };

    this.httpService.updateOfficeFlag(this.estimateId, this.service._id, flag, 'admin').then(
      (estimate: any) => {
        // this.service = estimate.service;
        this.updateServiceFlags(estimate);
        this.setOfficeFlag();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  openTechFlagNotes() {
    const flag = {
      viewed: true,
    };

    this.httpService.updateTechFlag(this.estimateId, this.service._id, flag, 'admin').then(
      (estimate: any) => {
        // this.service = estimate.service;
        this.updateServiceFlags(estimate);
        this.setTechFlag();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  updateServiceFlags(estimate) {
    const { isOfficeFlag, officeFlag, isTechFlag, openTechNote, tech, techFlag, openOfficeNote } = estimate.service;
    this.service.isOfficeFlag = isOfficeFlag;
    this.service.officeFlag = officeFlag;
    this.service.isTechFlag = isTechFlag;
    this.service.openTechNote = openTechNote;
    this.service.tech = tech;
    this.service.techFlag = techFlag;
    this.service.openOfficeNote = openOfficeNote;
  }

  setOfficeFlagIcon() {
    const defaultAsset = 'assets/img/raise-flag-icons';
    if (this.service?.officeFlag?.flagStatus === 'resolved') {
      return `${defaultAsset}/resolved-office-flag.svg`;
    } else if (this.service?.officeFlag?.techViewed && this.service?.officeFlag?.flagStatus === 'open') {
      return `${defaultAsset}/active-office-flag.svg`;
    } else if (!this.service?.officeFlag?.techViewed && this.service?.officeFlag?.flagStatus === 'open') {
      return `${defaultAsset}/unseen-office-flags.svg`;
    } else {
      return `${defaultAsset}/user-flag.svg`;
    }
  }

  setTechFlagColor() {
    const defaultAsset = 'assets/img/raise-flag-icons';
    if (this.service?.techFlag?.flagStatus === 'resolved') {
      // return 'notification-green';
      return `${defaultAsset}/resolved-tech-flag.svg`;
    } else if (!this.service?.techFlag?.adminViewed && this.service?.techFlag?.flagStatus === 'open') {
      // return 'notification-red';
      return `${defaultAsset}/unseen-tech-flag.svg`;
    } else if (this.service?.techFlag?.adminViewed && this.service?.techFlag?.flagStatus === 'open') {
      // return 'notification-yellow';
      return `${defaultAsset}/active-tech-flag.svg`;
    } else {
      // return 'notification-gray';
      return `${defaultAsset}/tech-flag.svg`;
    }
  }

  setServiceDetails() {
    try {
      this.serviceDetails = {
        imageIcon: this.serviceTitleIcons[this.service.itemSource]?.imageIcon ?? this.autoLeapManualService?.imageIcon,
        class: this.serviceTitleIcons?.[this.service.itemSource]?.class ?? this.autoLeapManualService?.class,
        altText: this.serviceTitleIcons?.[this.service.itemSource]?.altText ?? this.autoLeapManualService?.altText,
      };
    } catch (err) {
      console.log(err);
    }
  }

  deleteRowAndReplacePartsLookup(index, serviceItem) {
    this.service.items.splice(index, 1);
    this.generateDeleteItemLog(serviceItem);

    if (this.service.items.length === 0) {
      this.service.items.push({
        title: null,
        type: null,
        isTaxable: false,
        count: '',
        price: null,
        discount: JSON.parse(JSON.stringify(config.estimate.discountType[0])),
        discountAmt: null,
        taxAmt: null,
        subTotal: 0,
        tags: [],
      });
    }

    this.service = { ...this.service };
    this.updateService();
  }

  showFinalizedDisableTooltip() {
    if (this.isFinalizedRo) {
      return 'Sorry, cannot make changes to a finalized RO';
    }
    return null;
  }

  handleTsInspecionData(event: any) {
    if (this.service.inspection) {
      this.service.inspection.inspectionId = event;
    }
  }
}
